/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FcbRecherchePlanLocalisationClasseDto,
  FcbRecherchePlanLocalisationClasseDtoPaginatedResults,
  FilterCriteriaInfo,
  PlanLocalisationClasseSearch,
  SelectItem,
} from '../models/index';
import {
    FcbRecherchePlanLocalisationClasseDtoFromJSON,
    FcbRecherchePlanLocalisationClasseDtoToJSON,
    FcbRecherchePlanLocalisationClasseDtoPaginatedResultsFromJSON,
    FcbRecherchePlanLocalisationClasseDtoPaginatedResultsToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    PlanLocalisationClasseSearchFromJSON,
    PlanLocalisationClasseSearchToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
} from '../models/index';

export interface PlanLocalisationClasseBaseSearchRequest {
    PlanLocalisationClasseSearch?: PlanLocalisationClasseSearch;
}

export interface PlanLocalisationClasseGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface PlanLocalisationClasseGetSelectItemsRequest {
    searchField: string;
}

export interface PlanLocalisationClasseSaveRequest {
    FcbRecherchePlanLocalisationClasseDto?: FcbRecherchePlanLocalisationClasseDto;
}

/**
 * 
 */
export class PlanLocalisationClasseApi extends runtime.BaseAPI {

    /**
     */
    async planLocalisationClasseBaseSearchRaw(requestParameters: PlanLocalisationClasseBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbRecherchePlanLocalisationClasseDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/PlanLocalisationClasse/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlanLocalisationClasseSearchToJSON(requestParameters.PlanLocalisationClasseSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbRecherchePlanLocalisationClasseDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async planLocalisationClasseBaseSearch(requestParameters: PlanLocalisationClasseBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbRecherchePlanLocalisationClasseDtoPaginatedResults> {
        const response = await this.planLocalisationClasseBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planLocalisationClasseGetSearchCriteriasRaw(requestParameters: PlanLocalisationClasseGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/PlanLocalisationClasse/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async planLocalisationClasseGetSearchCriterias(requestParameters: PlanLocalisationClasseGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.planLocalisationClasseGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planLocalisationClasseGetSelectItemsRaw(requestParameters: PlanLocalisationClasseGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling planLocalisationClasseGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/PlanLocalisationClasse/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async planLocalisationClasseGetSelectItems(requestParameters: PlanLocalisationClasseGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.planLocalisationClasseGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planLocalisationClasseSaveRaw(requestParameters: PlanLocalisationClasseSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbRecherchePlanLocalisationClasseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/PlanLocalisationClasse`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FcbRecherchePlanLocalisationClasseDtoToJSON(requestParameters.FcbRecherchePlanLocalisationClasseDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbRecherchePlanLocalisationClasseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planLocalisationClasseSave(requestParameters: PlanLocalisationClasseSaveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbRecherchePlanLocalisationClasseDto> {
        const response = await this.planLocalisationClasseSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
